import { Card } from '@mui/material'
import React from 'react'
import { CreateBase as ReactAdminCreateBase, TransformData, useTranslate } from 'react-admin'
import { ListActionsWithPermission } from '../ra-rbac'
import { CreateBaseProps } from './type'

const defaultListAction = {
  hasCreate: false,
  hasExport: false,
  hasPreview: false,
  hasEdit: false,
  hasShow: false,
  hasList: true,
}

const CreateBase: React.FC<CreateBaseProps> = ({
  children,
  title,
  listAction = {},
  encType = 'application/json',
  convertToJson = [],
  noCard = false,
  transform: transformProps,
  ...props
}) => {
  const transform = (data): TransformData => {
    let transformaedData = data
    if (transformProps) {
      transformaedData = transformProps(transformaedData)
    }

    return {
      ...transformaedData,
      encType: encType,
      convertToJson: convertToJson,
    }
  }

  const translate = useTranslate()
  return (
    <ReactAdminCreateBase {...props} transform={transform}>
      <>
        {listAction && (
          <ListActionsWithPermission
            title={title ? translate(title) : ''}
            {...defaultListAction}
            {...listAction}
          />
        )}
        {!noCard ? <Card>{children}</Card> : children}
      </>
    </ReactAdminCreateBase>
  )
}

export default CreateBase
